//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 25/10/2024
// Version : 1
// Description : pantalla para tabla de checklist por grupo e items
//------Changes --------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../services/apirest";
import moment from "moment";
import {
  Typography,
  MenuItem,
  FormControl,
  Select,
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
} from "@mui/material";
import Navbar from "../../Navbar";
import { styled } from "@mui/system";
import { logEventos } from "../../../services/services";

function EstadisticaCheck() {
  const [tablaCheck, setTablaCheck] = useState([]);

  const [selectedDate, setSelectedDate] = useState(
    moment().subtract(1, "month").format("YYYY-MM")
  );
  const formattedDate = `${selectedDate}-01`;

  const [fechaString, setFechaString] = useState("");

  useEffect(() => {
    if (tablaCheck.fecha) {
      setFechaString(tablaCheck.fecha.toString());
    }
  }, [tablaCheck]);

  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setSelectedDate(newDate);

    // Actualiza datosCheck.fecha cuando cambia la selección
    setTablaCheck({
      ...tablaCheck,
      fecha: moment(newDate, "YYYY-MM").format("YYYY-MM-DD"), // Ajusta el formato según necesites
    });
  };

  const currentMonth = moment();
  const monthOptions = Array.from({ length: 12 }, (_, i) => {
    const month = currentMonth
      .clone()
      .subtract(i + 1, "months")
      .format("YYYY-MM");
    return {
      value: month,
      label: currentMonth
        .clone()
        .subtract(i + 1, "months")
        .format("MMMM YYYY"),
    };
  });

  const obtenerResultados = () => {
    const year = formattedDate.split("-")[0];
    const month = formattedDate.split("-")[1];

    // Construir la URL con el año y el mes
    const url = `${UrlApi}/checklist/checklistTabla/${year}/${month}`;

    fetch(url)
      .then((data) => data.json())
      .then((data) => setTablaCheck(data));
  };

  useEffect(() => {
    obtenerResultados();
  }, [selectedDate]);

  // console.log("TABLA CHECK", tablaCheck);

  const [deposito, setDeposito] = useState([]);

  const obtenerDepositos = () => {
    fetch(UrlApi + "/sucursales/xsucauth/" + localStorage.getItem("suc_auth"))
      .then((data) => data.json())
      .then((data) => setDeposito(data));
  };
  useEffect(() => {
    obtenerDepositos();
  }, []);

  // console.log("TABLA CHECK", tablaCheck);

  // *********************************************************** Tabla ********************************************************************** //
  useEffect(() => {
    logEventos(
      "acceso al menú Resumen Checklist",
      "Evaluacion Comerciales",
      "Resumen Checklist",
      localStorage.getItem("user")
    );
  }, []);
  return (
    <div>
      <Navbar />
      <Box
        bgcolor="#2B76A6"
        padding={1}
        borderRadius={0}
        color="white"
        textAlign="center"
        display="flex"
        alignItems="center"
        marginTop={1}
      >
        <Grid container alignItems="center">
          <Grid item>
            <Typography variant="h4" component="div">
              Tabla Checklist
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ height: "6vh" }}
        >
          <Grid item>
            <FormControl
              focused
              color="primary"
              sx={{
                backgroundColor: "white",
                width: "200px",
                display: "flex",
                justifyContent: "center",
              }}
              required
              size="small"
            >
              <Select
                required
                variant="outlined"
                name="mes"
                value={selectedDate}
                onChange={handleDateChange}
                labelId="mes"
              >
                {monthOptions.map((elemento) => (
                  <MenuItem key={elemento.value} value={elemento.value}>
                    {elemento.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>

      {/* Renderizado condicional */}
      {tablaCheck && tablaCheck.length > 0 ? (
        <TableContainer
          sx={{
            width: "100%",
            overflowX: "auto",
            maxHeight: "70vh",
            marginTop: 2,
          }}
        >
          <Table stickyHeader sx={{ minWidth: 900 }}>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#2B76A6",
                    color: "white",
                    borderRight: "1px solid black",
                    fontSize: "14px", // achica fuente
                    padding: "4px", // reduce padding interno
                    minWidth: 80, // controla ancho mínimo
                  }}
                >
                  <b>Fecha de auditoría</b>
                </TableCell>

                {deposito && deposito.length > 0 ? (
                  deposito.map((dep) => {
                    const auditoria = Array.isArray(tablaCheck)
                      ? tablaCheck.find((item) => item.sucursal === dep.nombre)
                      : null;

                    return (
                      <TableCell
                        key={dep.id}
                        sx={{
                          borderRight: "1px solid black",
                          textAlign: "center",
                          backgroundColor: "#2B76A6",
                          color: "white",
                          fontSize: "13px",
                          padding: "4px",
                          minWidth: 70, // ajusta ancho según necesites
                          maxWidth: 90,
                          whiteSpace: "nowrap", // evita salto de línea
                        }}
                      >
                        {auditoria && auditoria.auditado === 1
                          ? moment(
                              auditoria.fecha_auditado,
                              "YYYY-MM-DD"
                            ).format("DD-MM-YYYY")
                          : "-"}
                      </TableCell>
                    );
                  })
                ) : (
                  <TableCell>No hay sucursales</TableCell>
                )}
              </TableRow>

              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#2B76A6",
                    color: "white",
                    borderRight: "1px solid black",
                    fontSize: "14px",
                    padding: "4px",
                    minWidth: 80,
                  }}
                >
                  <b>Sucursales</b>
                </TableCell>
                {deposito && deposito.length > 0 ? (
                  deposito.map((dep) => (
                    <TableCell
                      key={dep.id}
                      sx={{
                        textAlign: "center",
                        backgroundColor: "#2B76A6",
                        color: "white",
                        fontSize: "13px",
                        padding: "6px 10px", // ajusta el espacio interno
                        whiteSpace: "nowrap", // evita saltos de línea
                        width: "auto", // se adapta al contenido
                        borderRight: "1px solid black",
                      }}
                    >
                      {dep.nombre}
                    </TableCell>
                  ))
                ) : (
                  <TableCell>No hay sucursales</TableCell>
                )}
              </TableRow>
            </TableHead>

            <TableBody>
              {tablaCheck && tablaCheck.length > 0
                ? Object.entries(
                    tablaCheck.reduce((acc, item) => {
                      if (!acc[item.nombre_grupo]) {
                        acc[item.nombre_grupo] = {
                          nombre_grupo: item.nombre_grupo,
                          items: {},
                        };
                      }
                      if (!acc[item.nombre_grupo].items[item.id_item]) {
                        acc[item.nombre_grupo].items[item.id_item] = {
                          id_item: item.id_item,
                          nombre_item: item.nombre_item,
                          sucursales: {},
                        };
                      }
                      acc[item.nombre_grupo].items[item.id_item].sucursales[
                        item.sucursal
                      ] = {
                        cumple: item.cumple_total > item.no_cumple_total,
                        noCumple: item.no_cumple_total > item.cumple_total,
                      };
                      return acc;
                    }, {})
                  ).map(([nombre_grupo, grupo]) => (
                    <React.Fragment key={nombre_grupo}>
                      {/* Fila para el nombre del grupo */}
                      <TableRow>
                        <TableCell
                          colSpan={deposito.length + 1}
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "#a7a2a2e5",
                            position: "sticky",
                            left: 0,
                            zIndex: 1,
                            fontSize: "14px",
                            padding: "6px 10px", // ajusta el espacio interno
                            whiteSpace: "nowrap", // evita saltos de línea
                            width: "auto", // se adapta al contenido
                            borderRight: "1px solid black",
                          }}
                        >
                          {grupo.nombre_grupo}
                        </TableCell>
                      </TableRow>
                      {/* Filas para los items del grupo */}
                      {Object.entries(grupo.items).map(([_, item]) => (
                        <TableRow key={item.id_item}>
                          <TableCell
                            sx={{
                              position: "sticky",
                              left: 0,
                              zIndex: 1,
                              backgroundColor: "#fff",
                              fontSize: "14px",
                              padding: "1px 1px", // ajusta el espacio interno
                              whiteSpace: "nowrap", // evita saltos de línea
                              width: "auto", // se adapta al contenido
                              borderRight: "1px solid black",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {item.nombre_item}
                          </TableCell>
                          {deposito.map((dep) => (
                            <TableCell
                              align="center"
                              sx={{
                                minWidth: 20,
                                fontSize: "14px",
                                padding: "1px 1px", // ajusta el espacio interno
                                whiteSpace: "nowrap", // evita saltos de línea
                                width: "auto",
                                borderRight: "1px solid black",
                                borderBottom: "1px solid black",
                              }}
                              key={dep.id}
                            >
                              {item.sucursales[dep.nombre]
                                ? item.sucursales[dep.nombre].cumple >
                                  item.sucursales[dep.nombre].noCumple
                                  ? "✔️"
                                  : item.sucursales[dep.nombre].cumple <
                                    item.sucursales[dep.nombre].noCumple
                                  ? "❌"
                                  : "-"
                                : "n/a"}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </React.Fragment>
                  ))
                : // <TableRow>
                  //   <TableCell
                  //     colSpan={deposito.length + 1}
                  //     sx={{
                  //       padding: "40px",
                  //       backgroundColor: "#DCDBD9",
                  //       color: "#4B4B4B",
                  //       fontStyle: "italic",
                  //       fontSize: "20px",
                  //     }}
                  //   >
                  //     No hay datos disponibles para esta fecha seleccionada.
                  //   </TableCell>
                  // </TableRow>
                  null}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // centra horizontal
            alignItems: "center", // centra vertical
            height: "30vh", // alto para centrar (ajustá según necesites)
          }}
        >
          <Box
            sx={{
              width: "90%",
              maxWidth: "600px", // límite opcional de ancho
              padding: "40px",
              backgroundColor: "#DCDBD9",
              color: "#4B4B4B",
              fontStyle: "italic",
              fontSize: "20px",
              textAlign: "center",
              border: "1px solid #aaa",
              borderRadius: "4px",
            }}
          >
            No hay datos disponibles para esta fecha seleccionada.
          </Box>
        </Box>
      )}
    </div>
  );
}

export default EstadisticaCheck;
